import apiClient from "@/common/gateway-api";
import * as Mutations from "@/store/mutations.type";
import * as Actions from "@/store/actions.type";
import * as Helpers from "@/helpers";

const CATEGORY_PAGE_SIZE = 1000;
// Safety net in case the endpoint ignores `page` and keeps returning a full page
const CATEGORY_MAX_PAGES = 50;

const parseCategoryPage = (res) => {
  const body = res && res.data ? res.data : {};
  const payload = body.data != null ? body.data : [];
  const items = Array.isArray(payload) ? payload : payload.items || [];
  const nextToken =
    (!Array.isArray(payload) && payload.nextToken) || body.nextToken || null;
  return {
    nextToken,
    count: items.length,
    categories: items.map((item) => ({ id: item.wooId, name: item.slug }))
  };
};

const fetchCategoryPage = (region, page, nextToken) =>
  apiClient.get("/api/v1/tyche/woocategories/search", {
    params: {
      itemsPerPage: CATEGORY_PAGE_SIZE,
      region,
      ...(page ? { page } : {}),
      ...(nextToken ? { nextToken } : {})
    }
  });

export default {
  [Actions.SET_CATEGORY_PAGE]({ commit }, page) {
    commit(Mutations.SET_CATEGORY_INSTANCE_PAGE, page);
  },
  [Actions.CATEGORY_INSTANCE_SEARCH]({ commit }, search) {
    commit(Mutations.SET_CATEGORY_SEARCH, search);
  },
  [Actions.CATEGORY_OPTIONS_SEARCH]({ commit }, search) {
    commit(Mutations.SET_CATEGORY_OPTIONS_SEARCH, search);
  },
  [Actions.SET_CATEGORY_LOADING_STATUS]({ commit }, { type, status }) {
    commit(Mutations.SET_CATEGORY_LOADING, {
      type,
      status
    });
  },
  [Actions.CLEAR_CATEGORY_ERRORS]({ commit }) {
    commit(Mutations.SET_CATEGORY_ERROR, null);
  },
  [Actions.CLEAR_CATEGORY_SUCCESS]({ commit }) {
    commit(Mutations.SET_CATEGORY_SUCCESS, null);
  },
  async [Actions.GET_CATEGORY_INFO]({ commit }, { region, hardRefresh }) {
    const day = 60 * 60 * 24 * 1000;
    let storageName =
      region === "au"
        ? "abi_category"
        : region === "nz"
        ? "abi_nz_category"
        : "abi_uk_category";
    if (
      !localStorage.getItem(storageName) ||
      Date.now() - JSON.parse(localStorage.getItem(storageName)).timestamp >
        day ||
      hardRefresh
    ) {
      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "mainLoading",
        status: true
      });
      fetchCategoryPage(region, 1)
        .then(async (res) => {
          let { categories, nextToken: token, count } = parseCategoryPage(res);
          let page = 1;

          while (
            (token || count === CATEGORY_PAGE_SIZE) &&
            page < CATEGORY_MAX_PAGES
          ) {
            page += 1;
            const result = await fetchCategoryPage(region, page, token);
            const nextPage = parseCategoryPage(result);
            if (!nextPage.count) break;
            token = nextPage.nextToken;
            count = nextPage.count;
            categories = categories.concat(nextPage.categories);
          }
          // add a new slug 'product-range'
          categories.push({ id: 0, name: "product-range" });
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "mainLoading",
            status: false
          });
          commit(Mutations.FETCH_CATEGORY_INFO, categories);
          commit(Mutations.FETCH_CATEGORY_SLUG_OPTIONS, categories);
          localStorage.setItem(
            storageName,
            JSON.stringify({ data: categories, timestamp: Date.now() })
          );
          commit(Mutations.SET_CATEGORY_SUCCESS, "Category Updated Success!");
          setTimeout(() => {
            commit(Mutations.SET_CATEGORY_SUCCESS, null);
          }, 5000);
        })
        .catch((error) => {
          commit(Mutations.SET_CATEGORY_ERROR, error.message);
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "mainLoading",
            status: false
          });
        });
    } else {
      commit(
        Mutations.FETCH_CATEGORY_INFO,
        JSON.parse(localStorage.getItem(storageName)).data
      );
      commit(
        Mutations.FETCH_CATEGORY_SLUG_OPTIONS,
        JSON.parse(localStorage.getItem(storageName)).data
      );
    }
  },
  [Actions.FETCH_EXIST_CATEGORY]({ commit }, { region, categoryId }) {
    return new Promise((resolve, reject) => {
      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "pageLoading",
        status: true
      });
      apiClient
        .get(`/api/v1/woo/components/instances/category/name/${categoryId}`, {
          params: {
            region
          }
        })
        .then((res) => {
          console.log(res);
          commit(Mutations.SET_EXIST_CATEGORY, res.data.data);
          resolve();
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "pageLoading",
            status: false
          });
        })
        .catch((err) => {
          reject(err);
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "pageLoading",
            status: false
          });
        });
    });
  },
  [Actions.FETCH_CATEGORY_ATTRIBUTES]({ commit }, { region, componentId }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/v1/woo/components/${componentId}/attributes`, {
          params: {
            region
          }
        })
        .then((res) => {
          const attributes = res.data.data;
          commit(Mutations.ADD_CATEGORY_ATTRIBUTES, {
            componentId,
            attributes
          });
          resolve();
        })
        .catch((err) => {
          commit(
            Mutations.SET_CATEGORY_ERROR,
            "Cannot fetch category Attributes!"
          );
          reject(err);
        });
    });
  },
  [Actions.ADD_CATEGORY_ERRORS]({ commit }, error) {
    commit(Mutations.SET_CATEGORY_ERROR, error);
  },
  async [Actions.CREATE_CATEGORY_INSTANCE](
    { commit },
    { region, formData, getComponentId, user }
  ) {
    commit(Mutations.SET_CATEGORY_LOADING, {
      type: "createLoading",
      status: true
    });
    try {
      // 1. create instance for content block
      // await Helpers.createComponentInstance(
      //   region,
      //   formData["abi_content_block"],
      //   getComponentId("abi_content_block"),
      //   user
      // );

      // 2. create instance for category faq
      await Helpers.createComponentInstance(
        region,
        formData["category_faq"],
        getComponentId("abi_category_faq"),
        user
      );

      // 3. create instances for content text block x 4
      const sections = ["faqs", "assistance", "range", "overview"];
      const requests = sections.map((item) =>
        Helpers.createComponentInstance(
          region,
          formData[`${item}_ctb`],
          getComponentId("abi_content_text_block"),
          user
        )
      );
      await Promise.all(requests);

      // 4. create instance for category page
      await Helpers.createComponentInstance(
        region,
        formData["category_page"],
        getComponentId("abi_category"),
        user
      );

      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "createLoading",
        status: false
      });
    } catch {
      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "createLoading",
        status: false
      });
      commit(Mutations.SET_CATEGORY_ERROR, "Cannot create instance!");
    }
  },
  async [Actions.UPDATE_CATEGORY_INSTANCE](
    { commit },
    { region, formData, user }
  ) {
    commit(Mutations.SET_CATEGORY_LOADING, {
      type: "updateLoading",
      status: true
    });
    try {
      // 1.Update instances for content text block x 4
      const sections = ["faqs", "assistance", "range", "overview"];
      const requests = sections.map((item) =>
        Helpers.updateComponentInstance(
          region,
          formData[`${item}_ctb`]["attributes"],
          formData[`${item}_ctb`]["id"],
          user
        )
      );

      await Promise.all(requests);
      // 2. update instance for category page
      await Helpers.updateComponentInstance(
        region,
        formData["category_page"]["attributes"],
        formData["category_page"]["id"],
        user
      );

      // 3. create instance for category faq
      await Helpers.updateComponentInstance(
        region,
        formData["category_faq"]["attributes"],
        formData["category_faq"]["id"],
        user
      );

      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "updateLoading",
        status: false
      });
      commit(Mutations.SET_CATEGORY_SUCCESS, "Category Updated Success!");
      setTimeout(() => {
        commit(Mutations.SET_CATEGORY_SUCCESS, "");
      }, 5000);
    } catch {
      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "updateLoading",
        status: false
      });
      commit(Mutations.SET_CATEGORY_ERROR, "Cannot update instance!");
    }
  },
  [Actions.FETCH_CATEGORY_INSTANCE]({ commit }, { region, categoryName }) {
    commit(Mutations.CLEAR_CATEGORY_INSTANCE);
    return new Promise((resolve, reject) => {
      commit(Mutations.SET_CATEGORY_LOADING, {
        type: "pageLoading",
        status: true
      });
      let categoryInstanceRequest = Helpers.fetchCategoryInstance(
        region,
        categoryName
      );
      let categoryUrlRequest = Helpers.fetchCategoryUrl(region, categoryName);
      const InstanceRequests = [categoryInstanceRequest, categoryUrlRequest];
      Promise.all(InstanceRequests)
        .then((res) => {
          commit(Mutations.CLEAR_CATEGORY_INSTANCE);
          commit(Mutations.SET_CATEGORY_INSTANCE, res[0].data.data);
          commit(Mutations.SET_PREVIEW_URL, res[1].data.data);
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "pageLoading",
            status: false
          });
          resolve();
        })
        .catch((err) => {
          commit(Mutations.CLEAR_CATEGORY_INSTANCE);
          commit(
            Mutations.SET_CATEGORY_ERROR,
            `${categoryName.replaceAll(
              "-",
              " "
            )} page have no instance, please create!`
          );
          commit(Mutations.SET_CATEGORY_LOADING, {
            type: "pageLoading",
            status: false
          });
          reject(err);
        });
    });
  },
  [Actions.CHANGE_CATEGORY_OPERATION]({ commit }, status) {
    commit(Mutations.SET_CATEGORY_OPERATION, status);
  }
};
